// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6744":"6db8bc2a","7614":"80be0453"}[chunkId] + ".chunk.css";
};